function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56602"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25864",
    d: "M14.779 9.865V5.712a3.462 3.462 0 1 0-6.923 0v4.153m10.482-1.84L19.5 19.1a1.038 1.038 0 0 1-1.033 1.147H4.163A1.038 1.038 0 0 1 3.13 19.1L4.3 8.026A1.038 1.038 0 0 1 5.329 7.1h11.976a1.038 1.038 0 0 1 1.033.926zM8.2 9.865a.346.346 0 1 1-.346-.346.346.346 0 0 1 .346.346zm6.923 0a.346.346 0 1 1-.346-.346.346.346 0 0 1 .348.346z",
    transform: "translate(.683 .75)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgBag;